<template lang="pug">
vm-row(class="section-heading" vm-w="12")
  vm-col(vm-type="flex" vm-align="center" vm-lg=8 vm-sm=12)
    div
      h2 {{ $t('quotations.summary') }}:
      span.description {{ $t('quotations.description_four') }}
  vm-col(class="section-heading__buttons" vm-type="flex" vm-align="flex-end" vm-justify="end" vm-lg=4 vm-sm=12)
    div
      vm-button(v-if="form.id" class="button_white" icon="copy-outline" @click="cloneReportQuotation(form.id)") {{ $t('quotations.clone')  }}
    div
      vm-button(v-if="form.id" class="button_white" icon="file-add-outline" @click="printReportQuotation(form.id)") {{ $t('quotations.download_pdf')  }}
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=12 class="section-custom")
    vm-col(vm-type="flex" vm-align="center" vm-lg=8 vm-sm=12)
      .section-custom__icon
        vm-icon(icon="clipboard-outline" size="1rem")
      span {{ $t('quotations.master_data') }}
    vm-col(vm-type="flex" vm-justify="end" vm-lg=4 vm-sm=12)
      div
        span {{ $t('quotations.folio') }}: {{form.folio}}
    vm-row(vm-align="center" vm-type="flex" vm-w=12 class="section-custom")
      vm-col(vm-type="flex" vm-lg=4 vm-sm=4 class="section-custom__inputs")
        span {{ $t('quotations.customer') }}
        p {{ form.customer ? form.customer.name : '' }}
      vm-col(vm-type="flex" vm-lg=4 vm-sm=4 class="section-custom__inputs")
        span {{ $t('quotations.contact') }}
        p {{ form.contact ? form.contact.name : ''}}
      vm-col(vm-type="flex" vm-lg=4 vm-sm=4 class="section-custom__inputs")
        span {{ $t('quotations.address') }}
        p {{ form.address }}
    vm-row(vm-align="center" vm-type="flex" vm-w=12 class="section-custom")
      vm-col(vm-type="flex" vm-lg=4 vm-sm=4 class="section-custom__inputs")
        span {{ $t('quotations.payment_conditions') }}
        p {{ form.payment_conditions }}
      vm-col(vm-type="flex" vm-lg=4 vm-sm=4 class="section-custom__inputs")
        span {{ $t('quotations.tax_type') }}
        p {{ form.tax_type }} %
      vm-col(vm-type="flex" vm-lg=4 vm-sm=4 class="section-custom__inputs")
        span {{ $t('quotations.currency') }}
        p {{ checkCurrency }}
    vm-row(vm-align="center" vm-type="flex" vm-w=12 class="section-custom")
      vm-col(vm-type="flex" vm-lg=4 vm-sm=4 class="section-custom__inputs")
        span {{ $t('quotations.branche') }}
        p {{ getBrancheName(form.branchIds) }}
    vm-row(vm-align="center" vm-type="flex" vm-w=12 class="section-custom")
      vm-col(vm-type="flex" vm-lg=4 vm-sm=4 class="section-custom__inputs")
        span {{ $t('quotations.requisite') }}
        ul(class="section-custom__ul")
          li(v-for="(id, index) in form.requisitionersIds"  :key="id") {{ getRequisitionersName(id) }}
      vm-col(vm-type="flex" vm-lg=4 vm-sm=4 class="section-custom__inputs")
        span {{ $t('quotations.additional_conditions') }}
        p(class="section-custom__inputs__notes-info") {{ form.additional_conditions }}
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=12 class="section-custom")
    vm-col(vm-type="flex" vm-align="center" vm-lg=12 vm-sm=12)
      .section-custom__icon
        vm-icon(icon="search-outline" size="1rem")
      span {{ $t('quotations.details_data') }}
    vm-row.table_products(vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        vm-table(max-height="350px" max-items="10" pagination :data="details" )
          template(slot="thead")
            vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('quotations.' + column) }}
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                slot(v-if="column == 'product'")  {{data[indextr]['name'] }}
                slot(v-if="column === 'quantity'") {{ data[indextr][column] }}
                slot(v-if="column == 'unit_price'")  {{data[indextr][column] | currency }}
                slot(v-if="column == 'amount'")  {{data[indextr][column] | currency }}
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=12 class="section-custom")
    vm-col(vm-type="flex" vm-align="center" vm-lg=12 vm-sm=12)
      .section-custom__icon
        vm-icon(icon="file-add-outline" size="1rem")
      span {{ $t('quotations.extra_information') }}
    vm-row(vm-align="center" vm-type="flex" vm-w=12 class="section-custom")
      vm-col(vm-type="flex" vm-lg=12 class="section-custom__inputs")
        span {{$t('quotations.attached_file')}}
        div(class="section-custom__card__grid" v-if="form.files.length")
          div(class="section-custom__card__grid__item" v-for='(file, index) in form.files' :key="index" @click="openViewer(file)")
            header
              img(:src='checkFormat(file.name)')
              span {{ getFileNameFormated(file.name) }}
    vm-row(vm-align="center" vm-type="flex" vm-w=12 class="section-custom")
      vm-col(vm-type="flex" vm-lg=8 vm-sm=8 class="section-custom__inputs")
        span {{$t('quotations.notes')}}
        p(class="section-custom__inputs__notes-info") {{ form.comments }}
      vm-col(vm-type="flex" vm-lg=4 vm-sm=4 class="section-custom__inputs-totals")
        span {{$t('quotations.totals')}}
        p(class="section-custom__inputs-totals__p") {{$t('quotations.subtotal')}}: {{ subtotal | currency }}
        p(class="section-custom__inputs-totals__p") {{$t('quotations.tax_amount')}}: {{ tax | currency }}
        p(class="section-custom__inputs-totals__p") {{$t('quotations.total')}}: {{ total | currency }}
</template>
<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Quotations')
export default {
  name: 'QuotationSummaryForm',
  mixins: [ViewMixinMaster1],
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    columns: ['product', 'unit_price', 'quantity', 'amount']
  }),
  computed: {
    ...mapGetters(['details', 'currencies', 'requisitioners', 'branches']),
    checkCurrency () {
      return this.form.currency_id ? this.currencies.find(e => e.id === this.form.currency_id).code : ''
    },
    subtotal () {
      return this.details ? this.details.reduce((acc, crr) => { return +acc + +crr.amount }, 0) : 0
    },
    tax () {
      return this.subtotal * (this.form.tax_type / 100)
    },
    total () {
      return this.subtotal + this.tax
    }
  },
  methods: {
    ...mapActions([
      'printReportQuotation',
      'cloneReportQuotation',
      'openFile'
    ]),
    getRequisitionersName (id) {
      return this.form.requisitionersIds ? this.requisitioners.find(requisitioners => requisitioners.id === id).name : ''
    },
    getBrancheName (id) {
      return this.form.branchIds ? this.branches.find(branches => branches.id === id).name : ''
    },
    getFileNameFormated (file) {
      return file.replace(/\.[^/.]+$/, '')
    },
    checkFormat (file) {
      const type = file.split('.').pop()
      if (type === 'dwg' || type === 'dxf') {
        return require('@/assets/icons/auto.png')
      } else if (type === 'pdf') {
        return require('@/assets/icons/pdf.svg')
      } else if (type === 'xls' || type === 'spread' || type === 'xlsx' || type === 'csv') {
        return require('@/assets/icons/excel.svg')
      } else {
        return require('@/assets/icons/pdf.svg')
      }
    },
    openViewer (record) {
      if (record.id && record.file_url) {
        this.openFile(record.file_url)
      }
    }
  }
}
</script>
<style lang="scss">
.section-heading {
  &__buttons {
    flex-direction: column;
  }
.button_white {
  background-color: transparent !important;
  font-size: 14px;
  color: black !important;
  display: flex;
  flex-direction: row-reverse;
  border: 1px solid black;
  margin: 5px;
  width: 150px;
  i {
    margin-left: 5px !important;
  }
}
}
.table_products {
  background-color: #F2F4F7;
  margin-top: 20px;
  .vm-table--tbody-table .tr-table tr {
    background-color: #F2F4F7 !important;
  }
  .vm-table--thead-table th {
    background-color: #E0E0E0 !important;
  }
  .vm-table--thead-table th.td-check {
    background-color: #E0E0E0 !important;
  }
}
.section-custom {
  margin: 20px 0;
  &__icon {
    margin-right: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    padding: 14px;
    border: 1px solid rgba($color: var(--gray), $alpha: 1.0);
    background-color: #F2F4F7;
    color: rgba($color: var(--primary), $alpha: 1.0);
  }
  &__inputs {
    flex-direction: column;
    &__notes-info {
      white-space: pre-line;
    }
    span {
      font-weight: 700;
      font-size: 12px;
      color: #8A8A8A;
    }
    p {
      font-weight: 400px;
      font-size: 14px;
    }
  }
  &__inputs-totals {
    flex-direction: column;
    background-color: #E0E0E0;
    border: 1px solid rgba($color: var(--primary), $alpha: 1.0);
    border-radius: 10px;
    padding: 20px 30px;
    width: calc(100% - 60px);
    span {
      font-weight: bold;
      font-size: 14px;
      color: rgba($color: var(--primary), $alpha: 1.0);
    }
    p {
      font-weight: 400px;
      font-size: 14px;
      color: black;
      margin: 8px 30px;
    }
  }
  span {
    font-weight: 600;
  }
  &__ul {
    display: flex;
    flex-wrap: wrap;
    font-size: 12px;
    margin: 10px;
    color: #8A8A8A;
    & li {
      margin-right: 22px;
    }
  }
  &__card {
    &__grid {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      grid-gap: 20px;
      &__item {
        &__dropdown {
          position: absolute;
          top: 0;
          right: 0;
        }
        & header {
          padding: 10px;
          display: flex;
          & img {
            width: 25px;
            margin-right: 10px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
